import { Navigate, Outlet, Route, Routes as Router } from "react-router-dom";
import { Login } from "src/pages/Commom/Login/Login";
import Homepage from "src/pages/Commom/Homepage/Homepage";
import EFPsicologosPage from "src/pages/Admin/EezyFamily/Psicologos/EFPsicologosPage";
import EFLocalizacoesPage from "src/pages/Admin/EezyFamily/Localizacoes/EFLocalizacoesPage";
import EFAbordagensPage from "src/pages/Admin/EezyFamily/Abordagens/EFAbordagensPage";
import EFUsuariosPage from "src/pages/Admin/EezyFamily/Usuarios/EFUsuariosPage";
import EFNotificacoesPage from "src/pages/Admin/EezyFamily/Notificacoes/EFNotificacoesPage";
import EFRelatorioFinanceiroPage from "src/pages/Admin/EezyFamily/RelatorioFinanceiro/EFRelatorioFinanceiroPage";
import { getStoredToken } from "../utils/auth";
import RegisterUser from "src/pages/Admin/RegisterUser.tsx/RegisterUser";
import ServicesByColaborator from "src/pages/Admin/ServicesByColaborator/ServicesByColaborator";
import Users from "src/pages/Admin/Users/Users";
import FinancialControl from "src/pages/Psichologists/FinancialControl/FinancialControl";
import MyActions from "src/pages/Psichologists/MyActions/MyActions";
import MyServices from "src/pages/Psichologists/MyServices/MyServices";
import Negotiations from "src/pages/Psichologists/Negotiations/Negotiations";
import RegisterAction from "src/pages/Psichologists/RegisterAction/RegisterAction";
import RegisterService from "src/pages/Psichologists/RegisterService/RegisterService";
import RegisterNegotiation from "src/pages/Admin/RegisterNegotiation/RegisterNegotiation";
import Companies from "src/pages/Admin/Companies/Companies";
import RegisterCompany from "src/pages/Admin/RegisterCompany/RegisterCompany";
import Collaborators from "src/pages/Admin/Collaborators/Collaborators";
import RegisterCollaborator from "src/pages/Admin/RegisterCollaborator/RegisterCollaborator";
import ChangePassword from "src/pages/Psichologists/ChangePassword/ChangePassword";
import ServicesByPsychologist from "src/pages/Admin/ServicesByPsychologist/ServicesByPsychologist";
import ServicesByCompany from "src/pages/Admin/ServicesByCompany/ServicesByCompany";
import CompanyRequests from "src/pages/Company/CompanyRequests/CompanyRequests";
import RegisterCompanyRequest from "src/pages/Company/RegisterCompanyRequest/RegisterCompanyRequest";
import MyCompany from "src/pages/Company/MyCompany/MyCompany";
import ForgotPassword from "src/pages/Commom/ForgotPassword/ForgotPassword";
import RecoverPassword from "src/pages/Commom/RecoverPassword/RecoverPassword";
import RegisterCollaboratorMassive from "src/pages/Admin/RegisterCollaboratorMassive/RegisterCollaboratorMassive";
import RegisterNotificationPage from "src/pages/Admin/RegisterNotification/RegisterNotification";
import { AllServicesPage } from "src/pages/Admin/AllServices/AllServicesPage";
import FeedbackPage from "src/pages/Psichologists/Feedback/Feedback";
import Feedbacks from "src/pages/Admin/Feedbacks/Feedbacks";
import Pacientes from "src/pages/Psichologists/Pacientes/Pacientes";
import RelatorioFinanceiroPage from "src/pages/Admin/RelatorioFinanceiro/RelatorioFinanceiroPage";
import FinancialSummaryPage from "src/pages/Company/FinancialSummary/FinancialSummaryPage";
import EmergencyRequests from "src/pages/Psichologists/EmergencyRequests/EmergencyRequests";
import CompanyJoinRequests from "src/pages/Admin/CompanyJoinRequests/CompanyJoinRequests";
import DashboardAttendance from "src/pages/Commom/DashboardAttendance/DashboardAttendance";
import SuaEmpresa from "src/pages/Company/SuaEmpresa/SuaEmpresa";
import ManageActions from "src/pages/Admin/ManageActions/ManageActions";
import DiaryEntry from "src/pages/Admin/DiaryEntry/DiaryEntry";
import EezyGuardForm from "src/pages/Public/EezyGuardForm/EezyGuardForm";
import EezyGuardAdminDashboard from "src/pages/Admin/EezyGuard/EezyGuardAdminDashboard";
import EezyGuardAdminOccurrences from "src/pages/Admin/EezyGuard/EezyGuardAdminOccurrences";
import EezyGuardAdminOccurrenceDetail from "src/pages/Admin/EezyGuard/EezyGuardAdminOccurrenceDetail";
import EezyGuardCompanyPage from "src/pages/Company/EezyGuard/EezyGuardCompanyPage";
import EezyGuardCompanyOccurrenceDetail from "src/pages/Company/EezyGuard/EezyGuardCompanyOccurrenceDetail";
import EezyOneLanding from "src/pages/Company/EezyOne/EezyOneLanding";
import EezycoinOfferingsPage from "src/pages/Admin/Eezycoin/Offerings/EezycoinOfferingsPage";
import EezycoinOfferingsFormPage from "src/pages/Admin/Eezycoin/Offerings/EezycoinOfferingsFormPage";

export type RouteDefinition = {
  name?: string;
  path?: string;
  element?: React.ReactElement;
  hideFromMenu?: boolean;
  innerRoutes?: RouteDefinition[];
};

export const CompanyPrivateRoutes: RouteDefinition[] = [
  {
    name: "Dashboard de Atendimentos",
    path: "/dashboard",
    element: <DashboardAttendance />,
  },
  {
    name: "Métricas de engajamento",
    path: "/sua-empresa",
    element: <SuaEmpresa />,
  },
  {
    name: "Minha empresa",
    path: "/empresa/minha",
    element: <MyCompany />,
  },
  {
    name: "Solicitações de Vinculação",
    path: "/vinculacoes",
    element: <CompanyJoinRequests />,
  },
  {
    name: "Solicitações",
    path: "/solicitacoes",
    element: <CompanyRequests />
  },
  {
    name: "Solicitações",
    path: "/solicitacoes/cadastro",
    element: <RegisterCompanyRequest />,
    hideFromMenu: true,
  },
  {
    name: "Colaboradores",
    path: "/colaboradores",
    element: <Collaborators />
  },
  {
    name: "Importar Colaboradores",
    path: "/colaboradores/importar",
    element: <RegisterCollaboratorMassive />,
    hideFromMenu: true,
  },
  {
    name: "Atendimentos",
    path: "/atendimentos/empresa",
    element: <ServicesByCompany />
  },
  {
    name: "Resumo financeiro",
    path: "/empresa/resumo-financeiro",
    element: <FinancialSummaryPage />,
  },
  {
    name: "EezyLine",
    path: "/eezyguard/empresa",
    element: <EezyGuardCompanyPage />,
  },
  {
    name: "Ocorrência EezyLine",
    path: "/eezyguard/empresa/ocorrencias/:id",
    element: <EezyGuardCompanyOccurrenceDetail />,
    hideFromMenu: true,
  },
  {
    name: "EezyOne",
    path: "/eezyone",
    element: <EezyOneLanding />,
    hideFromMenu: true,
  },
];

// Sidebar reduzida para empresas com EezyOne desligado (só compraram EezyGuard):
// mostra a landing EezyOne (upsell) + o módulo EezyGuard.
export const CompanyEezyOnlyRoutes: RouteDefinition[] = [
  {
    name: "EezyOne",
    path: "/eezyone",
    element: <EezyOneLanding />,
  },
  {
    name: "EezyLine",
    path: "/eezyguard/empresa",
    element: <EezyGuardCompanyPage />,
  },
];

export const PsychologistPrivateRoutes: RouteDefinition[] = [
  {
    name: "Meus Atendimentos",
    path: "/atendimentos",
    element: <MyServices />,
  },
  {
    name: "Pacientes",
    path: "/pacientes",
    element: <Pacientes />,
  },
  {
    name: "Adicionar atendimento",
    path: "/atendimentos/cadastro",
    element: <RegisterService />,
    hideFromMenu: true,
  },
  {
    name: "Editar Atendimento",
    path: "/atendimentos/:id/editar",
    element: <RegisterService />,
    hideFromMenu: true,
  },
  {
    name: "Minhas ações realizadas",
    path: "/acoes",
    element: <MyActions />,
  },
  {
    name: "Adicionar ação realizada",
    path: "/acoes/cadastro",
    element: <RegisterAction />,
    hideFromMenu: true,
  },
  {
    name: "Negociações",
    path: "/negociacao",
    element: <Negotiations />,
  },
  {
    name: "Controle financeiro",
    path: "/financeiro/controle",
    element: <FinancialControl />,
  },
  {
    name: "Alterar senha",
    path: "/usuario/alterar-senha",
    element: <ChangePassword />,
    hideFromMenu: true,
  },
  {
    name: "Feedback interno",
    path: "/feedbacks",
    element: <FeedbackPage />,
  },
  {
    name: "Solicitações Emergenciais",
    path: "/solicitacoes-emergenciais",
    element: <EmergencyRequests />,
  },
];

export const AdminPrivateRoutes: RouteDefinition[] = [
  {
    name: "Balanço Financeiro",
    path: "/relatorio-financeiro",
    element: <RelatorioFinanceiroPage />,
  },
  {
    name: "Usuários",
    path: "/usuario",
    element: <Users />
  },
  {
    name: "Adicionar usuário",
    path: "/usuario/cadastro",
    element: <RegisterUser />,
    hideFromMenu: true,
  },
  {
    name: "Editar usuário",
    path: "/usuario/:id/editar",
    element: <RegisterUser />,
    hideFromMenu: true,
  },
  {
    name: "Empresas",
    path: "/empresa",
    element: <Companies />
  },
  {
    name: "Adicionar empresa",
    path: "/empresa/cadastro",
    element: <RegisterCompany />,
    hideFromMenu: true,
  },
  {
    name: "Editar empresa",
    path: "/empresa/:id/editar",
    element: <RegisterCompany />,
    hideFromMenu: true,
  },
  {
    name: "Colaboradores",
    path: "/colaboradores",
    element: <Collaborators />
  },
  {
    name: "Adicionar Colaborador",
    path: "/colaboradores/cadastro",
    element: <RegisterCollaborator />,
    hideFromMenu: true,
  },
  {
    name: "Importar Colaboradores",
    path: "/colaboradores/importar",
    element: <RegisterCollaboratorMassive />,
    hideFromMenu: true,
  },
  {
    name: "Editar Colaborador",
    path: "/colaboradores/:id/editar",
    element: <RegisterCollaborator />,
    hideFromMenu: true,
  },
  {
    name: "Negociações",
    path: "/negociacao",
    element: <Negotiations />,
  },
  {
    name: "Solicitações",
    path: "/solicitacoes",
    element: <CompanyRequests />
  },
  {
    name: "Adicionar Negociação",
    path: "/negociacao/cadastro",
    element: <RegisterNegotiation />,
    hideFromMenu: true,
  },
  {
    name: "Editar Negociação",
    path: "/negociacao/:id/editar",
    element: <RegisterNegotiation />,
    hideFromMenu: true,
  },
  {
    name: "Novo comunicado",
    path: "/comunicados/cadastro",
    element: <RegisterNotificationPage />
  },
  {
    name: "Feedbacks",
    path: "/feedbacks/admin",
    element: <Feedbacks />,
  },
  {
    name: "Gerenciar ações",
    path: "/acoes/gerenciar",
    element: <ManageActions />,
  },
  {
    name: "Entrada Diário",
    path: "/diario/entrada",
    element: <DiaryEntry />,
  },
  {
    name: "Solicitações Emergenciais",
    path: "/solicitacoes-emergenciais",
    element: <EmergencyRequests />,
  },
  {
    name: "Solicitações de Vinculação",
    path: "/vinculacoes",
    element: <CompanyJoinRequests />,
  },
  {
    name: "Atendimentos",
    innerRoutes: [
      {
        name: "Atendimentos por colaborador",
        path: "/atendimentos/colaborador",
        element: <ServicesByColaborator />
      },
      {
        name: "Atendimentos por empresa",
        path: "/atendimentos/empresa",
        element: <ServicesByCompany />
      },
      {
        name: "Atendimentos por psicólogo",
        path: "/atendimentos/psicologo",
        element: <ServicesByPsychologist />
      },
      {
        name: "Todos os atendimentos",
        path: "/atendimentos/todos",
        element: <AllServicesPage />
      },
    ]
  },
  {
    name: "EezyFamily",
    innerRoutes: [
      {
        name: "Psicólogos",
        path: "/eezyfamily/psicologos",
        element: <EFPsicologosPage />,
      },
      {
        name: "Localizações",
        path: "/eezyfamily/localizacoes",
        element: <EFLocalizacoesPage />,
      },
      {
        name: "Abordagens",
        path: "/eezyfamily/abordagens",
        element: <EFAbordagensPage />,
      },
      {
        name: "Usuários",
        path: "/eezyfamily/usuarios",
        element: <EFUsuariosPage />,
      },
      {
        name: "Notificações",
        path: "/eezyfamily/notificacoes",
        element: <EFNotificacoesPage />,
      },
      {
        name: "Relatório Financeiro",
        path: "/eezyfamily/relatorio-financeiro",
        element: <EFRelatorioFinanceiroPage />,
      },
    ],
  },
  {
    name: 'EezyCoin',
    innerRoutes: [
      {
        name: 'Ofertas',
        path: '/eezycoin/ofertas',
        element: <EezycoinOfferingsPage />,
      },
      {
        path: '/eezycoin/ofertas/cadastro',
        element: <EezycoinOfferingsFormPage />,
        hideFromMenu: true,
      },
      {
        path: '/eezycoin/ofertas/:id/editar',
        element: <EezycoinOfferingsFormPage />,
        hideFromMenu: true,
      },
    ]
  }
];

// Rotas administrativas do EezyGuard — registradas para navegação, mas o menu
// é exibido apenas para os administradores EezyGuard (gate por capability no Header).
export const EezyGuardAdminRoutes: RouteDefinition[] = [
  {
    name: "Dashboard EezyLine",
    path: "/eezyguard",
    element: <EezyGuardAdminDashboard />,
  },
  {
    name: "Todas as Ocorrências",
    path: "/eezyguard/ocorrencias",
    element: <EezyGuardAdminOccurrences />,
  },
  {
    name: "Ocorrência EezyLine",
    path: "/eezyguard/ocorrencias/:id",
    element: <EezyGuardAdminOccurrenceDetail />,
    hideFromMenu: true,
  },
];

export const PrivateRoutes: RouteDefinition[] = [
  ...CompanyPrivateRoutes,
  ...PsychologistPrivateRoutes,
  ...AdminPrivateRoutes,
  ...EezyGuardAdminRoutes,
];

function PrivateRoutesMiddleware() {
  const hasToken = getStoredToken();

  if (!hasToken) return <Navigate to="/login" replace />;

  return <Outlet />;
}

export default function Routes() {
  return (
    <Router>
      <Route path="/login" element={<Login />} />
      <Route path="/esqueci-minha-senha" element={<ForgotPassword />} />
      <Route path="/recuperar-senha" element={<RecoverPassword />} />
      <Route path="/eezyguard/denuncia/:slug" element={<EezyGuardForm />} />
      <Route element={<PrivateRoutesMiddleware />}>
        <Route path="/" element={<Homepage />} />
        {PrivateRoutes.map((route) => {
          if (route.innerRoutes !== undefined && route.innerRoutes?.length > 0) {
            return route?.innerRoutes?.map((r) => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))
          }

          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
      </Route>
    </Router>
  );
}
